<div class="bundle-offer" [attr.data-testid]="'ancillary-bundle-passenger-' + passenger().id">
  <div class="flex flex--space-between flex--middle ms-small-b">
    <h4 class="font-heading-5 font-title-medium nordic-blue-900-text">{{ passengerName() }}</h4>
    @if (selectedForPassenger()) {
      <fcom-button
        [attr.data-testid]="'ancillary-bundle-remove-' + passenger().id"
        [text]="'ancillaries.bundle.toggle.buttonText.removeCombo' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        (clickBtn)="removeCombo.emit()"
      />
    } @else if (availability()?.availableInCatalog) {
      <fcom-button
        [attr.data-testid]="'ancillary-bundle-add-' + passenger().id"
        [text]="'ancillaries.bundle.upsellCard.buttonText.addCombo' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
        [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        (clickBtn)="addCombo.emit()"
      />
    }
  </div>

  @if (availability()?.availableInCatalog || selectedForPassenger()) {
    <div class="bundle-services flex flex--nowrap">
      @for (service of constituents(); track service.category; let isLast = $last) {
        <div
          class="bundle-service flex-1 flex--basis0 flex flex--column"
          [attr.data-testid]="'ancillary-bundle-service-' + service.category"
        >
          <fin-bundle-service-card [service]="service" [inCart]="selectedForPassenger()" />
        </div>

        @if (!isLast) {
          <div class="bundle-services__plus flex flex--center flex--middle ps-small-x">
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.PLUS" />
          </div>
        }
      }

      <div
        class="bundle-offer__price nordic-blue-25-bg rounded-medium flex flex--column flex--center flex--middle pr-xsmall"
      >
        @if (availability()?.itemsWithoutBundlePrice; as originalPrice) {
          <span class="strike-through font-body-2" data-testid="ancillary-bundle-original-price">{{
            originalPrice | finPrice
          }}</span>
        }
        <span
          class="font-heading-5 font-title-small heather-800-text"
          [attr.data-testid]="'ancillary-bundle-price-' + passenger().id"
          >{{ availability()?.bundleTotalPrice | finPrice }}</span
        >
      </div>
    </div>
  } @else {
    <fcom-notification
      class="block"
      [attr.data-testid]="'ancillary-bundle-unavailable-' + passenger().id"
      [theme]="NotificationTheme.INFO"
      [scale]="NotificationScale.SMALL"
    >
      <span>{{ 'ancillaries.bundle.unavailableBundle' | finLocalization }}</span>
    </fcom-notification>
  }
</div>
